import { makeStyles } from 'makeStyles';
import {
  BACKGROUND_RED,
  BLUE_BACKGROUND_WRAPPER,
  BLUE_BACKGROUND_WRAPPER_BORDER,
  STATUS_GREEN,
  STATUS_GREEN_BG,
  STATUS_RED,
  STATUS_RED_BG,
} from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  eventsTypography: {
    color: theme.palette.primary.main,
  },
  paidWrapper: {
    backgroundColor: STATUS_GREEN_BG,
    display: 'inherit',
    padding: '0 5px',
  },
  paidTypography: {
    color: STATUS_GREEN,
    fontSize: 12,
    fontWeight: 600,
  },
  notPaidWrapper: {
    backgroundColor: STATUS_RED_BG,
    display: 'inherit',
    padding: '0 5px',
  },
  notPaidTypography: {
    color: STATUS_RED,
    fontSize: 12,
    fontWeight: 600,
  },
  showing: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    alignItems: 'end',
  },
  paginationToolbar: {
    [theme.breakpoints.up('xs')]: {
      height: '42px',
      minHeight: '42px',
    },
    overflow: 'hidden',
    '& p': {
      margin: '0',
    },
  },
  showingGridItem: {
    alignSelf: 'end',
  },
  showingTypography: {
    fontSize: 13,
    fontWeight: 600,
  },
  searchInputAdornment: {
    padding: 0,
  },
  eventSelect: {
    height: '36px',
  },
  pointer: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  penaltyList: {
    listStyle: 'none',
    fontSize: 14,
    color: BACKGROUND_RED,
    lineHeight: 1.6,
    padding: 0,
    margin: 0,
  },
  title: {
    marginBottom: 16,
  },
  bulkIconGridItem: {
    height: 24,
    marginTop: 2,
  },
  bulkSelectActionContainer: {
    background: BLUE_BACKGROUND_WRAPPER,
    border: `1px solid ${BLUE_BACKGROUND_WRAPPER_BORDER}`,
    padding: '8px 10px',
  },
  bulkSelectActions: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  selectedTypography: {
    fontWeight: 600,
  },
  downloadIcon: {
    width: 16,
    height: 16,
  },
}));
